<template>
  <base-card
    title="Informasi Pengeluaran"
    description="Daftar pengeluaran yang akan dikirim ke Stockist Center"
  >
    <div class="grid grid-cols-3 gap-6 border-t pt-5">
      <base-input
        v-if="order.attributes.order_shipment === 'delivery'"
        class="col-span-full"
        inset
        type="text"
        label="Nomor Resi"
        placeholder="Nomor Resi"
        v-model="stockMovement.data.attributes.airwaybill_number"
        @change="onSubmit"
      />
      <base-input
        v-else
        class="col-span-full"
        inset
        type="text"
        label="Diambil Oleh"
        placeholder="Diambil Oleh"
        v-model="stockMovement.data.attributes.taken_by"
        @change="onSubmit"
      />
    </div>

    <loading v-if="loading" />
  </base-card>
</template>

<script>
import { requestMixin } from '../../mixins/request/request';

export default {
  mixins: [requestMixin],
  props: {
    value: Object,
    order: Object,
  },
  emits: ['input'],
  data() {
    return {
      loading: false,
    };
  },
  computed: {
    stockMovement: {
      get() {
        return this.value;
      },
      set(value) {
        this.$emit('input', value);
      },
    },
  },
  methods: {
    async onSubmit() {
      this.loading = true;

      await this.request(
        `/api/v1/stock-movements/${this.stockMovement.data.id}`,
        {
          method: 'patch',
          data: {
            data: {
              type: 'stock-movements',
              id: this.stockMovement.data.id,
              attributes: {
                ...(this.order.attributes.order_shipment === 'delivery'
                  ? {
                      airwaybill_number:
                        this.stockMovement.data.attributes.airwaybill_number,
                    }
                  : { taken_by: this.stockMovement.data.attributes.taken_by }),
              },
            },
          },
        }
      );

      this.loading = false;
    },
  },
};
</script>
